import { render, staticRenderFns } from "./mineRecommends.vue?vue&type=template&id=6514134c&scoped=true&"
import script from "./mineRecommends.vue?vue&type=script&lang=js&"
export * from "./mineRecommends.vue?vue&type=script&lang=js&"
import style0 from "./employ.css?vue&type=style&index=0&id=6514134c&scoped=true&lang=css&"
import style1 from "./mineRecommends.css?vue&type=style&index=1&id=6514134c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6514134c",
  null
  
)

export default component.exports